module.exports = __webpack_public_path__ + "static/media/training.72d501bb.png";